import { render, staticRenderFns } from "./PatientDispenses.html?vue&type=template&id=77571de1&external"
import script from "./PatientDispenses.js?vue&type=script&lang=js&external"
export * from "./PatientDispenses.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports